import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  img: {
    width: 'auto',
  },
});

type LogoFullProps = {
  /** Rendered height of the logo, in px. Defaults to 30 (the login page size). */
  height?: number;
};

const LogoFull = ({ height = 30 }: LogoFullProps) => {
  const classes = useStyles();

  return (
    <img
      className={classes.img}
      style={{ height }}
      src="/cypremos-logo.png"
      alt="Cypremos"
    />
  );
};

export default LogoFull;
